var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._g({staticClass:"icon",class:("icon--" + (_vm.size.toLowerCase()))},_vm.$listeners),[_vm._t("default",null,null,{ size: _vm.size, solid: _vm.solid })],2)}
var staticRenderFns = []

export { render, staticRenderFns }